import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  count: 0,
  draftItems: [],
};

const draftSlice = createSlice({
  name: "drafts",
  initialState,
  reducers: {
    incrementDraftCount: (state) => {
      state.count += 1;
    },
    decrementDraftCount: (state) => {
      state.count = Math.max(0, state.count - 1);
    },
    setDraftCount: (state, action) => {
      state.count = action.payload;
    },

    addDraftItem: (state, action) => {
      const newDraft = {
        ...action.payload,
        id: action.payload.id || Date.now(),
      };
      state.draftItems.push(newDraft);
      state.count = state.draftItems.length;
    },

    removeDraftItem: (state, action) => {
      state.draftItems = state.draftItems.filter(
        (draft) => draft.id !== action.payload.id
      );
      state.count = state.draftItems.length;
    },

    updateDraftItem: (state, action) => {
      const index = state.draftItems.findIndex(
        (draft) => draft.id === action.payload.id
      );
      if (index !== -1) {
        state.draftItems[index] = action.payload;
      }
    },

    clearAllDrafts: (state) => {
      state.draftItems = [];
      state.count = 0;
    },

    // Optional: Clear drafts on logout
    clearDraftsOnLogout: () => initialState,
  },
});

export const {
  incrementDraftCount,
  decrementDraftCount,
  setDraftCount,
  addDraftItem,
  removeDraftItem,
  updateDraftItem,
  clearAllDrafts,
  clearDraftsOnLogout
} = draftSlice.actions;

export default draftSlice.reducer;